import React, { useEffect } from 'react';

const Modal = ({ isOpen, onClose, content }) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('modal-overlay')) {
      onClose();
    }
  };

  // Inject onClose as a prop to the content
  const contentWithClose = React.isValidElement(content) 
    ? React.cloneElement(content, { onClose: onClose })
    : content;

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal">{contentWithClose}</div>
    </div>
  );
};

export default Modal;